export default __webpack_public_path__ + "static/media/delete-icon.96c36184.svg";